import { Link } from 'react-router-dom';
import styled from 'styled-components';

export const PageContainer = styled.div`
  max-width: 600px;
  margin: 0 auto;
  text-align: left;
  color: var(--text);
`;

export const Title = styled.h1`
  color: var(--text);
  font-weight: 550;
`;

export const SettingsBox = styled.div`
  border: 1px solid var(--border);
  border-radius: 2px;
  background-color: var(--surface);
  box-shadow: 2px 2px 0 rgba(0, 0, 0, 0.06);
`;

export const Section = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 16px;

  & + & {
    border-top: 1px solid var(--border);
  }
`;

export const SectionContent = styled.div`
  flex: 1;
  min-width: 0;
  max-width: 400px;
`;

export const SectionTitle = styled.h3`
  font-size: 16px;
  font-weight: 550;
  margin: 0 0 4px 0;
`;

export const BackLink = styled(Link)`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 14px;
  color: var(--active-blue);
  text-decoration: none;
  margin-bottom: 16px;

  &:hover {
    text-decoration: underline;
  }
`;

export const ConfirmInput = styled.input`
  border: 1px solid var(--border);
  padding: 8px;
  font-size: 14px;
  width: 100%;
  box-sizing: border-box;
  margin-top: 8px;
`;

export const StatusText = styled.p`
  font-size: 14px;
  color: var(--text-muted);
  margin: 4px 0;
`;

export const SectionAction = styled.div`
  flex-shrink: 0;
  display: flex;
  align-items: center;

  button,
  a {
    width: 100px;
  }
`;

export const ActiveSubscriptionNotice = styled.p`
  font-size: 14px;
  color: var(--text-muted);
  margin: 4px 0 12px;
  opacity: 0.8;
`;
